import { VirtusIcon } from '@virtus/components/icons';
import { Route } from '@virtus/components/page/models/route';

const topRightMenuItems: any[] = [];

export default (
  routes: Route[],
): {
  routes: {
    name: string;
    mainLogo: {
      component: typeof VirtusIcon;
      props: {
        style: {
          width: string;
        };
      };
    };
    path: string;
    active: number;
    subroutes: Route[];
  };
  topRightMenuItems: any[];
} => ({
  routes: {
    name: 'root',
    mainLogo: {
      component: VirtusIcon,
      props: {
        style: {
          width: '100px',
        },
      },
    },
    path: '',
    active: 0,
    subroutes: routes,
  },
  topRightMenuItems,
});
